import React from 'react';
import './AdminPage.scss';
import Title from '../../shared/components/title/Title';
import Tabs from '../../shared/components/tabs/Tabs';
import { TabItem } from '../../shared/components/tabs/models/TabsModel';
import { useAccount } from '../../shared/contexts/account/AccountContexts';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import useIsMobile from '../../shared/hooks/global/UseIsMobile';
import MobilePageHeader from '../../shared/components/common/mobile-menu/MobilePageHeader';
import {
  AdminResource,
  getAdminPermissions,
} from '../../shared/models/admin/permissions/AdminPermission';

interface AdminProps {
  children: React.ReactNode;
  restUrl: string;
}

const AdminPage: React.FC<AdminProps> = ({ children, restUrl }) => {
  const { accountResponse } = useAccount();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const permissions = getAdminPermissions(accountResponse);

  // Each tab appears only when its resource's read permission allows it.
  const menuItems: TabItem[] = [
    ...(permissions[AdminResource.DASHBOARD].read
      ? [
          {
            icon: 'dashboard',
            url: `/admin/dashboard`,
            label: 'Dashboard',
            isActive: restUrl === 'dashboard',
          },
        ]
      : []),
    ...(permissions[AdminResource.ACCOUNTS].read
      ? [
          {
            icon: 'password',
            url: `/admin/accounts`,
            label: 'Accounts',
            isActive: restUrl === 'accounts',
          },
        ]
      : []),
    ...(permissions[AdminResource.REPORTS].read
      ? [{ icon: 'reports', url: `/admin/reports`, label: 'Reports', isActive: restUrl === 'reports' }]
      : []),
    ...(permissions[AdminResource.SETTINGS].read
      ? [
          {
            icon: 'settings',
            url: `/admin/settings`,
            label: 'Settings',
            isActive: restUrl === 'settings',
          },
        ]
      : []),
    ...(permissions[AdminResource.SOURCE_VERIFICATION].read
      ? [
          {
            icon: 'sources',
            url: `/admin/source-verification`,
            label: 'Source Verification',
            isActive: restUrl === 'source-verification',
          },
        ]
      : []),
    ...(permissions[AdminResource.NOTIFICATIONS].read
      ? [
          {
            icon: 'bell',
            url: `/admin/notifications`,
            label: 'Notifications',
            isActive: restUrl === 'notifications',
          },
        ]
      : []),
    ...(permissions[AdminResource.INTERCOM].read
      ? [
          {
            icon: 'bell',
            url: `/admin/intercom`,
            label: 'Intercom',
            isActive: restUrl === 'intercom',
          },
        ]
      : []),
    ...(permissions[AdminResource.COSTS].read
      ? [{ icon: 'reports', url: `/admin/costs`, label: 'Costs', isActive: restUrl === 'costs' }]
      : []),
    ...(permissions[AdminResource.CLI_COMMANDS].read
      ? [
          {
            icon: 'settings',
            url: `/admin/cli-commands`,
            label: 'CLI commands',
            isActive: restUrl === 'cli-commands',
          },
        ]
      : []),
    ...(permissions[AdminResource.PERMISSIONS].read
      ? [
          {
            icon: 'password',
            url: `/admin/permissions`,
            label: 'Permissions',
            isActive: restUrl === 'permissions',
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="admin-page page-content">
        <div className="page-box">
          {/* Telefon: zakładki (za dużo na szerokość ekranu) jako dropdown w górnym pasku — w miejscu
              tytułu, bo pokazuje nazwę aktywnej zakładki (jak w Ustawieniach). */}
          <MobilePageHeader
            title={
              <Dropdown
                value={menuItems.find((item) => item.isActive)?.url}
                onChange={(e) => navigate(e.value)}
                options={menuItems.map((item) => ({ label: item.label, value: item.url }))}
                className="dropdown admin-page__tabs-dropdown"
              />
            }
          />
          {!isMobile && (
            <>
              <Title title={menuItems.filter((item) => item.isActive)[0]?.label ?? ''} />
              <Tabs items={menuItems} additionalClass="page-box__tabs" />
            </>
          )}
          <div className="page-box__content">
            <main>{children}</main>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPage;
